import { Carousel, CarouselItem } from '@ixigo/iui/Carousel';
import { useApiData } from '@repo/shared/hooks';
import { SectionHeader } from '@/components/section-header';
import { UpcomingBookingCard } from '@/components/upcoming-booking';
import {
	fetchUpcomingTrips,
	type UpcomingTripsResponse,
} from '@/components/upcoming-booking/api';
import { useLogin } from '@/lib/login';

export const UpcomingTrips = () => {
	const { isUserLoggedIn } = useLogin();

	const [{ data, status, error }] = useApiData<UpcomingTripsResponse['data']>(
		async () => {
			const tripsResponse = await fetchUpcomingTrips();

			if ('errors' in tripsResponse) {
				throw new Error('Failed to fetch upcoming trips');
			}
			return tripsResponse.data;
		},
		[],
		{
			enabled: isUserLoggedIn,
		},
	);

	// Compute values
	const cabBookings = data || [];
	const hasTrips = Boolean(cabBookings.length > 0);
	const isLoading = status === 'loading' || status === 'refreshing';

	// Don't render the section if there are no trips and we're not loading
	if (error || (status === 'idle' && !hasTrips) || isLoading) {
		return null;
	}

	return (
		<div className="bg-primary pt-20 pb-10 flex flex-col">
			<SectionHeader title="Upcoming Trips" className="pl-20" />
			<Carousel
				scrollSnapAlign="center"
				className={`py-10 ${cabBookings.length > 1 ? 'pl-20 pr-20' : 'px-20'}`}
			>
				{cabBookings.map((booking) => (
					<CarouselItem
						key={booking.bookingId}
						className={`shadow-100 rounded-20 ${
							cabBookings.length > 1 ? 'w-300px' : 'w-full'
						}`}
					>
						<UpcomingBookingCard bookingInfo={booking} loading={isLoading} />
					</CarouselItem>
				))}
			</Carousel>
		</div>
	);
};
